// ReferralControllerApi  getReferralById

import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { ReferralControllerApi } from "../../../services";
import { getConfigObject } from "../../../utils/utils";

interface Props {
  referralId: string;
  xTENANTID: string;
}

/**
 *
 * @author Atish Bagate
 *
 */
export const useGetReferralById = ({ referralId, xTENANTID }: Props): any => {
  return useQuery({
    queryKey: ["referral-by-id", referralId, xTENANTID],
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
    enabled: !!referralId && !!xTENANTID,
    queryFn: async () =>
      await new ReferralControllerApi(getConfigObject())
        .getReferralById(referralId, xTENANTID)
        .then((res) => res?.data),
  });
};
